import { useEffect, useState } from "react";
import Title from "./mainpage/Title";
import "./App.css";
import VerticalFlexbox from "./mainpage/VerticalFlexbox";
import Margin from "./Margin";
import Projects from "./mainpage/Projects";
import WorkExperience from "./mainpage/WorkExperience";
import Education from "./mainpage/Education";
import BlogPage from "./blogpage/BlogPage";
import BlogPostPage from "./blogpage/BlogPostPage";
import { getSavedLanguage, LANGUAGE_STORAGE_KEY } from "./blogpage/blogLanguage";
import Sidebar from "./Sidebar";
import useScrollTheme from "./useScrollTheme";
import "./theme.css";

const isMobile = window.innerWidth <= 768;
const BLOG_ROUTE = "#/blog";
const BLOG_POST_PREFIX = "#/blog/";

const getCurrentRoute = () => {
  const hash = window.location.hash || "#/";

  if (hash.startsWith(BLOG_POST_PREFIX)) {
    const slug = hash.replace(BLOG_POST_PREFIX, "").split("/")[0];
    return { page: "blogPost", slug };
  }

  if (hash.startsWith(BLOG_ROUTE)) {
    return { page: "blog" };
  }

  const section = hash.slice(1);
  return { page: "home", section: ["projects", "work-experience", "education"].includes(section) ? section : null };
};

function App() {
  const [route, setRoute] = useState(getCurrentRoute);
  const [language, setLanguage] = useState(getSavedLanguage);
  const { theme, toggleTheme } = useScrollTheme(route.page === "home");

  const changeLanguage = (value) => {
    setLanguage(value);
    try {
      window.localStorage.setItem(LANGUAGE_STORAGE_KEY, value);
    } catch {
      // Keep the switch usable when browser storage is unavailable.
    }
  };

  useEffect(() => {
    const handleHashChange = () => {
      setRoute(getCurrentRoute());
    };

    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  useEffect(() => {
    if (route.section) {
      document.getElementById(route.section)?.scrollIntoView({ block: "start" });
    } else {
      window.scrollTo(0, 0);
    }
  }, [route]);

  const navigate = (event, href) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (window.location.hash !== href) window.history.pushState(null, "", href);
    setRoute(getCurrentRoute());
  };

  let content;
  if (route.page === "blog") {
    content = <BlogPage language={language} onLanguageChange={changeLanguage} />;
  } else if (route.page === "blogPost") {
    content = <BlogPostPage slug={route.slug} language={language} onLanguageChange={changeLanguage} />;
  } else {
    content = (
      <main>
        {isMobile ? <Margin size={2}/> : <Margin size={3}/>}
        <VerticalFlexbox>

          <Title/>

          <Margin size={3}/>

          <Projects/>
          <WorkExperience/>
          <Education/>
          <p>building website...</p>
          <Margin size={3}/>
        </VerticalFlexbox>
      </main>
    );
  }

  return (
    <>
      <Sidebar route={route} onNavigate={navigate} theme={theme} onToggleTheme={toggleTheme} />
      <div className="site-content">{content}</div>
    </>
  );
}

export default App;
